import "../styles/auth.css";
import "../styles/download-apk.css";

const APK_FILE_NAME = "Khaal APK.apk";
const APK_URL = `/${encodeURIComponent(APK_FILE_NAME)}`;

function DownloadApkPage() {
  return (
    <main className="auth-page">
      <section className="auth-card download-apk-card">
        <img
          className="auth-logo"
          src="/alkhidmat-logo.png"
          alt="Alkhidmat logo"
          width="120"
          height="120"
        />
        <h1>Download APK</h1>
        <p className="subtitle">Click the button to download APK.</p>
        <a
          className="primary-btn full-width download-apk-btn"
          href={APK_URL}
          download={APK_FILE_NAME}
        >
          Download APK
        </a>
      </section>
    </main>
  );
}

export default DownloadApkPage;
